'use client';

import { Typography } from '@mui/material';
import { Button } from '@nrdy-marketing-engine/button';
import PhoneCall from '@nrdy-marketing-engine/components/svg/phone-call.svg?svgr';
import formatPhoneNumber from '@nrdy-marketing-engine/phone-number/src/format-phone-number';
import React from 'react';

interface CallNowFooterBannerProps {
  getStartedText?: string;
  phoneNumber?: string;
  target?: string;
}

function scrollWindowToTop() {
  setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0);
}

const Text = ({ children, className }: React.PropsWithChildren<{ className?: string }>) => (
  <Typography className={`font-normal text-white font-normal text-base ${className}`}>
    {children}
  </Typography>
);

/**
 * A Banner that contains the proper phone number for users to contact customer service, Used as a CTA in the bottom side
 **/
function CallNowFooterBanner({
  phoneNumber = '8888880446',
  getStartedText = 'View your quote',
  target,
}: CallNowFooterBannerProps) {
  return (
    <section className="flex-col lg:flex-row flex justify-center items-center bg-[#0D0D3D] p-6 gap-4">
      <div className="flex lg:flex-row lg:items-center">
        <PhoneCall className="scale-75" />
        <div className="ml-2 lg:flex lg:flex-row lg:gap-2">
          <Text>Still have more questions?</Text>
          <Text>
            Call us
            <a className="underline ml-2" href={`tel:+1${phoneNumber}`}>
              {formatPhoneNumber(phoneNumber)}
            </a>
          </Text>
        </div>
      </div>
      <div className="hidden h-8 w-px bg-white lg:block" />
      <Text className="text-center">Ready to start your membership?</Text>
      <Button
        className="border h-10 text-sm font-medium"
        onClick={scrollWindowToTop}
        target={target}
        variant="secondary"
      >
        {getStartedText}
      </Button>
    </section>
  );
}

export default CallNowFooterBanner;
